import { render, staticRenderFns } from "./TrainingPlanV2.vue?vue&type=template&id=5188dfd2"
import script from "./TrainingPlanV2.vue?vue&type=script&lang=js"
export * from "./TrainingPlanV2.vue?vue&type=script&lang=js"
import style0 from "./TrainingPlanV2.vue?vue&type=style&index=0&id=5188dfd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports